import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class OverlayService {

  isOverlayVisible: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  showOverlay(value: boolean) {
    this.isOverlayVisible.next(value);
  }
}
